import { useSetRecoilState } from "recoil";
import { getTranslatedIssueStatusNameString } from "lib/helper/getTranslatedRowDataStrings";
import { useEffect } from "react";
import translations from "translations";
import { errorReportStatusAtom } from "./recoil";

export const ErrorReportsFilterDataLoader = () => {
  const errorReportStatuses = translations.enums.issueStatusName;

  const errorReportStatusKeyValue = Object.keys(errorReportStatuses).map((key) => ({
    key: key,
    value: getTranslatedIssueStatusNameString(key) ?? "",
  }));

  const setErrorReportStatus = useSetRecoilState(errorReportStatusAtom);

  useEffect(() => {
    setErrorReportStatus(errorReportStatusKeyValue);
  }, [setErrorReportStatus, errorReportStatusKeyValue]);

  return null;
};
